module.exports = __webpack_public_path__ + "static/img/logo.0d300e97.png";